module.exports = __webpack_public_path__ + "static/Eva Cadelino-db58ac940c465a10a56ea77dc472bdf5.png";